export default __webpack_public_path__ + "static/media/Chang.603c60b2.jpg";